import { render, staticRenderFns } from "./BranchesSettings.vue?vue&type=template&id=6f31cb71"
import script from "./BranchesSettings.vue?vue&type=script&lang=js"
export * from "./BranchesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports